import { OptionType, SearchableSelect } from "shared";
import React, { useEffect, useState } from "react";
import { useSharedTranslations } from "../../lib/i18n";
import { TagItem } from "./tag_item/tag_item";
import styles from "./tag-select.module.scss";

interface ITagSelectProps {
    value: string[];
    loading?: boolean;
    options: OptionType[];
    placeholder?: string;
    validate?: boolean;
    triggerValidate?: number;
    onChange: (options: string[]) => void

}

export const TagSelect: React.FC<ITagSelectProps> = React.memo(({
                                                                    value,
                                                                    options,
                                                                    loading,
                                                                    validate,
                                                                    triggerValidate,
                                                                    placeholder,
                                                                    onChange
                                                                }) => {
    const [selectedOptions, setSelectedOptions] = useState<OptionType[]>([]);
    const t = useSharedTranslations();

    useEffect(() => {
        setSelectedOptions(options.filter((o) => value.includes(o.value)))
    }, [value, options])

    const onSelectOption = (val: string) => {
        const valOption = options.find(o => o.value === val);
        if (valOption) {
            setSelectedOptions((prevState) => {
                const updatedState = [...prevState];
                updatedState.push(valOption);
                onChange(updatedState.map(o => o.value));
                return updatedState;
            })
        }
    }

    const onRemove = (val: string) => {
        setSelectedOptions((prevState) => {
            const updatedState = [...prevState];
            const indexToRemove = prevState.findIndex(o => o.value === val);
            updatedState.splice(indexToRemove, 1);
            onChange(updatedState.map(o => o.value));
            return updatedState;
        })
    }

    return <div className={styles.container}>
        <SearchableSelect
            options={options.filter((o) => !selectedOptions.map(s => s.value).includes(o.value))}
            placeholder={placeholder}
            loading={loading}
            validate={validate}
            triggerValidate={triggerValidate}
            internalOptionsValue={selectedOptions}
            validateMessage={t("addField")}
            onChange={(val) => onSelectOption(val as string)}
            closeMenuOnSelect={false}
            displayValueInSelect={false}
            isMulti={false}
            hideClearIcon={true}
            isSearchable={true}
        />
        {selectedOptions.length > 0 && <div className={styles.selectedItemsContainer}>
            {selectedOptions.map((selectedOption) => <TagItem option={selectedOption}
                                                              key={selectedOption.value}
                                                              onRemove={onRemove}/>)}
        </div>}
    </div>
});
